import { Section } from "Components/Section";
import { WhatIsThisModal } from "Components/WhatIsThisModal";
import { VerticalRadio } from "Inputs/Radio";
import React from "react";
import { NohaCoverageModel } from "SharedConstants/Schema";
import { formatDollarsAndCents, formatWholeDollars } from "Tools";

type NohaCoverageItem =
  | {
      ID: number;
      Limit: number;
      Premium: number | null;
      NeedsUnderwriting: true;
    }
  | {
      ID: number;
      Limit: number;
      Premium: number;
      NeedsUnderwriting: false;
    };

function NohaCoverageText(props: NohaCoverageItem) {
  if (props.NeedsUnderwriting) {
    if (props.Premium == null) {
      return (
        <>
          {formatWholeDollars(props.Limit)} Limit Non-Owned/Hired Auto Liability
          Coverage will require a supplemental application.{" "}
          <span className="is-italic">
            This coverage is not available for purchase online. If you select
            this option, our underwriter will contact you shortly
          </span>
          .
        </>
      );
    } else {
      return (
        <>
          {formatWholeDollars(props.Limit)} Limit Non-Owned/Hired Auto Liability
          Coverage will require a supplemental application. Premium to be
          determined by Underwriter. Subject to a{" "}
          <span className="has-text-weight-bold">
            {formatDollarsAndCents(props.Premium)} Minimum Premium
          </span>
          .
        </>
      );
    }
  } else {
    if (props.Premium == 0) {
      return (
        <>
          Decline This Coverage (
          <span className="has-text-weight-bold">No Additional Cost</span>)
        </>
      );
    } else {
      return (
        <>
          {formatWholeDollars(props.Limit)} Limit Non-Owned / Hired Auto
          Liability Coverage can be added for an Additional Premium of{" "}
          <span className="has-text-weight-bold">
            {formatDollarsAndCents(props.Premium)}
          </span>{" "}
          <span className="is-italic">(Fully Earned at Inception)</span>
        </>
      );
    }
  }
}

export function NohaCoverageSection(props: NohaCoverageModel) {
  return (
    <Section
      title={
        <>
          Non-Owned / Hired Auto Liability Coverage{" "}
          <WhatIsThisModal modalTitle="Non-Owned / Hired Auto Liability">
            Non-Owned and Hired Automobile Liability Insurance provides
            financial protection against suits arising from bodily injury and/or
            property damage due to use of a hired and non-owned automobile.{" "}
            <br />
            <br /> 15-passenger vans are excluded from this coverage.
          </WhatIsThisModal>
        </>
      }
    >
      <div style={{ margin: "auto", maxWidth: "75%" }}>
        <VerticalRadio
          fieldName="NohaRate"
          options={props.NohaCoverageItems.map(e => [
            e.ID.toString(),
            <NohaCoverageText {...(e as NohaCoverageItem)} />,
          ])}
          hasBorderedArea
        />
      </div>
    </Section>
  );
}
